export const ALLCANDIDATES = "ALLCANDIDATES";
export const ALLINTERVIEW = "ALLINTERVIEW";
export const JOBPOST = "JOBPOST";
export const ALLQR = "ALLQR";
export const VIEWQRBYID = "VIEWQRBYID";